import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthStateService } from './auth-state.service';
import { UiService } from './ui.service';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})
export class HasRightsGuard {

  constructor(
    private auth: AuthStateService,
    private ui: UiService,
    private transloco: TranslocoService
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let right = route.data?.right;
    if (route.params?.id === 'new' && route.data?.rightCreate) {
      right = route.data?.rightCreate;
    }
    if (right === undefined || this.auth.hasRight(right)) {
      return true;
    } else {
      this.ui.toastError(this.transloco.translate('auth.no_permission'), this.transloco.translate('common.error'));
      return false;
    }
  }

}
